import React from 'react';
import { withStyles } from "@mui/styles";
import {FormControl, InputLabel, MenuItem, OutlinedInput, Select,} from '@mui/material';
import {ViewIconIcon, ViewListIcon, ViewStreamIcon} from '../../../helpers/Icons'

const styles = {
  select: {
    boxSizing:'border-box',
    height: '34px',
    backgroundColor: '#ffffff',
    '& > div:first-child': {
      boxSizing: 'border-box',
      height: '34px',
      padding: '6px 32px 6px 14px',
      '& > span:last-child': {
        display: 'none'
      }
    }
  }
};

function ViewModeControl(props) {
  const {
    viewMode, setViewMode, viewModeOptions,
    classes
  } = props;

  const viewModeIcons = {
    'List': <ViewListIcon style={{fontSize:'20px'}} />,
    'Icon': <ViewIconIcon style={{fontSize:'20px'}} />,
    'Stream': <ViewStreamIcon style={{fontSize:'20px'}} />,
  };

  return (
    <>
      {viewModeOptions.length > 1 ? (
        <FormControl
          variant="outlined"
        >
          <InputLabel style={{flexShrink: 0, transform: 'translate(14px, -6px) scale(1)', fontSize: '0.7225em'}}>
            View:
          </InputLabel>
          <Select
            id="dataViewMode"
            className={classes.select}
            value={viewMode}
            onChange={setViewMode}
            input={<OutlinedInput margin='dense' label="View Mode"/>}
          >
            {viewModeOptions.map((mode) => (
              <MenuItem key={mode} value={mode}>{viewModeIcons[mode]}<span style={{paddingLeft:'0.5rem'}}>{mode}</span></MenuItem>
            ))}
          </Select>
        </FormControl>
      ) : null }
    </>
  )
}

export default withStyles(styles)(ViewModeControl);
